import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Button } from '@/components/atoms/Button';

export const SearchMunicipalityBottomSheetFooter = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const Buttons = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 3),
}));

interface StyledContentProps {
  overflowY?: 'auto' | 'hidden';
  variant?: 'municipality' | 'advanced';
}

export const StyledContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'overflowY',
})<StyledContentProps>(({ theme, overflowY, variant }) => ({
  height: variant === 'municipality' ? '80%' : '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(3),
  overflowY,
}));

export const StyledMunicipalityButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: '38px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.primary,
  '&:hover': {
    borderColor: theme.palette.primary.light,
    backgroundColor: theme.palette['mint-green'][100],
    color: theme.palette.primary.dark,
  },
}));
